module.exports = __webpack_public_path__ + "media/icons/user-circle-c421599b2802adab747a7ef9d9ca0b8e.svg";